








import Vue from 'vue';
import Component from 'vue-class-component';
import { Global } from '@/store';
import Utils from '@/modules/Utils';
import { Watch } from 'vue-property-decorator';

@Component({})
class About extends Vue {
    version_num = 'v-2.67.1.9';
    @Global.Mutation('setPageTitle') setPageTitle;
    @Global.State('timezone') timezone;

    utils = Utils;
    versionDisplay = '';

    mounted() {
        this.setPageTitle('About');
        this.versionDisplay = this.getVersion();
    }

    getVersion() {
        return this.version_num.includes('v') 
            ? this.version_num 
            : this.version_num && this.timezone 
                ? this.utils.convertTimestamp(this.version_num, 'DD-MM-YY HH:mm:ss', this.timezone) 
                : this.version_num || 'Unknown';
    }

    @Watch('timezone')
    onTimezoneChanged() {
        this.versionDisplay = this.getVersion();
    }
}

export default About;
